<template>
  <div class="pickup-grid">
    <div class="pickup-tx-wrap" data-text="ComfortNewTownJikiba.">
      <div class="pickup-tx">
        <h3>オーダー可能な新築プラン販売開始！</h3>
        <h4>ComfortNewTownJikiba</h4>
        <p>
          新築住宅が月々63,859円から！
          私たちが自信を持ってお勧めするモデルプランをもとに、お客様のご要望に合わせてカスタマイズ可能な新築物件です。
          <br />
          暮らしに便利な立地で、あなたの理想の住まいを作りませんか？
          <br />
          お気軽にご相談ください。
        </p>
        <div class="pickup-button">
          <a href="/contact">お問い合わせはこちら</a>
        </div>
      </div>
    </div>
    <div class="pickup-img">
      <img
        src="images/banner/nagai24V-EtoI.jpg"
        alt="コンフォートニュータウン食場"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {},
};
</script>

<style lang="scss" scoped>
$color: #1c5095;
#pickup {
  width: 100%;
  height: 100%;
  .pickup-grid {
    display: flex;
    background-color: white;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    margin-top: 2rem;
    @include tb {
      flex-direction: column-reverse;
    }
    .pickup-tx-wrap {
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50%;
      padding: 4rem;
      position: relative;
      z-index: 1;
      @include tb {
        width: 100%;
        padding: 2rem;
      }
      &::after {
        content: attr(data-text);
        position: absolute;
        left: 1rem;
        bottom: 0.5rem;
        font-size: 3rem;
        opacity: 0.15;
        color: $color;
        z-index: -1;
        white-space: pre;
        @include tb {
          writing-mode: vertical-lr;
          right: 0.5rem;
          left: auto;
          font-size: 1rem;
        }
      }
    }
    .pickup-tx {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 1rem;
      @include tb {
        width: 100%;
      }

      h3 {
        font-size: 2.5rem;
        font-weight: bold;
        @include tb {
          font-size: 2rem;
        }
        @include sp {
          font-size: 1.5rem;
        }
      }

      h4 {
        font-size: 1rem;
        color: $color;
        padding-bottom: 1rem;
        position: relative;

        font-weight: bold;
        &::after {
          content: "";
          display: block;
          width: 2rem;
          height: 1px;
          background-color: $color;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
      p {
        font-weight: normal;
        line-height: 2;
      }
      a {
        font-weight: bold;
        font-size: 1rem;
        padding: 0.5rem 1rem;
        color: $color;
        background-color: white;
        border: 2px solid $color;
        border-radius: 2rem;
        align-self: start;
        margin-right: 0.5rem;
        display: inline-block;
        @include sp {
          font-size: 0.8rem;
        }
      }
    }
    .pickup-img {
      overflow: hidden;
      border-radius: 1rem 0 0 1rem;
      width: 50%;
      position: relative;
      z-index: 0;
      &::after {
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: $color;
        z-index: -1;
        opacity: 0.25;
      }
      @include tb {
        width: 100%;

        border-radius: 0;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  h2 {
    font-weight: bold;
    font-size: 3rem;
    margin-bottom: 1em;

    padding: 0 $h-gap;
    span {
      margin-left: 1em;
      font-size: 1rem;
    }
  }
  p {
    font-size: 1rem;
  }
}
.pickup-list {
  @include tb {
    grid-template-columns: repeat(3, 1fr);
  }
  @include sp {
    grid-template-columns: repeat(2, 1fr);
  }
  .swiper {
    overflow: visible;
  }
}
</style>
